module.exports = __webpack_public_path__ + "static/media/featured-image.a17f34b1.jpg";